import React, { useState } from "react";
import TagButton from "../common/TagButton";
import useCase1 from "../../assets/Home/useCase1.svg";
import useCase2 from "../../assets/Home/useCase2.svg";
import TabSelector from "../Offering/TabSelector";
import { useScreen } from "../../context/ScreenContext";

const cardA = ["Business Leaders", "Technology Leaders", "Talent Leaders"];
const cardB = [
  [
    {
      heading: "Contact Center AI",
      text: "Automate frontline conversations with voice and text agents that speak your brand. Multilingual, CRM-integrated, and built for self-service and assisted support alike.",
    },
    {
      heading: "Agentic Platforms",
      text: "Deploy modular agents to drive operations from workflows and escalations to document processing. Built for business teams that want control without deep tech lift.",
    },
  ],
  [
    {
      heading: "CQ -",
      subHeading: "Code Intelligence",
      text: "Accelerate software delivery with GenAI-assisted code generation, auto-documentation, and debug automation. Ideal for teams looking to reduce cycle time without compromising quality.",
    },
    {
      heading: "TQ -",
      subHeading: "Testing Intelligence",
      text: "Enable self-healing test frameworks with AI-driven case generation, automated QA, and intelligent error detection—cutting manual effort and speeding up deployment confidence.",
    },
  ],
  [
    {
      heading: "Recruitment Copilot",
      text: "Run 1,000+ structured interviews at scale using AI-powered assessments—screen for skill, culture fit, and learning agility with minimal overhead.",
    },
    {
      heading: "Training Agents",
      text: "Deliver adaptive onboarding and skills development through conversational agents. Personalized learning paths, feedback loops, and built-in tracking—all powered by GenAI.",
    },
  ],
];

const UseCases = () => {
  const { isMobile } = useScreen();
  const [cardIndex, setCardIndex] = React.useState(0);
  const [selected, setSelected] = useState("Business");
  const handleClick = (index) => {
    setCardIndex(index);
  };
  return (
    <div
      className={`flex items-center justify-center w-full h-[780px] md:h-[743px] bg-cover bg-center px-[20px] lg:px-0`}
    >
      <div className="flex flex-col items-start gap-[36px] w-full lg:w-[1440px] lg:px-[120px]">
        <TagButton text="Customized For You" />
        <div className="flex flex-col gap-[30px] items-start md:mt-0">
          <div
            className="lg:w-[576px] bg-gradient-to-r from-black to-t-blue-1 bg-clip-text text-transparent font-montserrat text-[24px] lg:text-[40px] not-italic font-semibold leading-[133.1%] inline-block w-fit"
            style={{
              backgroundImage: "linear-gradient(90deg, #000 0%, #0060C7 100%)",
            }}
          >
            {cardA[cardIndex].split(" ")[0]} Use Cases
          </div>
          {isMobile && (
            <TabSelector
              tabs={cardA.map((title) => title.split(" ")[0])}
              selected={selected}
              setSelected={setSelected}
              setSelectedIndex={setCardIndex}
            />
          )}
          {/* <div className="lg:px-[24px] lg:py-[20px] text-black lg:text-white font-roboto text-[16px] lg:text-[24px] not-italic font-light leading-[160%] tracking-[-0.4px] lg:bg-[#04336B] lg:rounded-lg flex w-full lg:w-[636px] h-[104px] lg:h-[220px] justify-center items-center gap-[10px]">
            Explore how Think41's GenAI stack delivers value across roles from
            engineering and ops to talent and CX. Use cases built to drive
            scale, speed, and smarter decision-making.
          </div> */}
          <div className=" w-[100%] text-[#444] font-montserrat text-[16px] not-italic font-normal leading-[160%] tracking-[-0.48px] lg:mb-[60px]">
            Explore how Think41's GenAI stack delivers value across roles from
            engineering and ops to talent and CX. Use cases built to drive
            scale, speed, and smarter decision-making.
          </div>
        </div>
        <div className="flex gap-[102px] w-full">
          <div className=" lg:flex flex-col justify-between hidden">
            {cardA.map((card, index) => (
              <div
                className={`p-[18px] w-[486px] font-montserrat cursor-pointer lg:text-[24px] text-[#04336B] lg:font-semibold ${
                  index === cardIndex
                    ? "bg-[#F0F7FF] border-[2px] border-[#04336B]"
                    : "bg-[#FAFAFAF5] border-[1px] border-[#6B6B6B]"
                } rounded-[8px]`}
                key={index}
                onClick={() => handleClick(index)}
              >
                {card}
              </div>
            ))}
          </div>
          <div className="flex lg:flex-row flex-col gap-[24px] mx-auto">
            <div className="border-[0.5px] border-[#D9D9D9] lg:border lg:border-[#04336B] relative w-full lg:w-[306px] h-[178px] lg:h-[279px] rounded-[8px] bg-[rgba(255,255,255,0.56)] backdrop-blur-[2px] pt-[20px] px-[24px] lg:p-[23px]">
              <img src={useCase1} className="absolute right-0 top-0 -z-10" />
              <p className="text-black font-montserrat text-[16px] lg:text-[24px] font-semibold leading-normal mb-[14px] lg:mb-[18px]">
                {cardB[cardIndex][0].heading}
                <span className="text-black font-montserrat text-[16px] font-semibold leading-none">
                  {cardB[cardIndex][0].subHeading && (
                    <span className="pl-[4px]">
                      {cardB[cardIndex][0].subHeading}
                    </span>
                  )}
                </span>
              </p>
              <p className="text-black font-roboto text-[14px] md:text-[16px] font-light leading-[160%] tracking-[-0.32px]">
                {cardB[cardIndex][0].text}{" "}
              </p>
            </div>
            <div className="border-[0.5px] border-[#D9D9D9] lg:border lg:border-[#04336B] relative overflow-hidden w-full lg:w-[306px] h-[178px] lg:h-[279px] rounded-[8px] bg-[rgba(255,255,255,0.56)] backdrop-blur-[2px] pt-[20px] px-[24px] lg:p-[23px]">
              <img
                src={useCase2}
                className="absolute -right-10 -top-[150px] -z-10"
              />
              <p className="text-black font-montserrat text-[16px] lg:text-[24px] font-semibold leading-normal mb-[18px]">
                {cardB[cardIndex][1].heading}
                <span className="text-black font-montserrat text-[16px] font-semibold leading-none">
                  {cardB[cardIndex][1].subHeading && (
                    <span className="pl-[4px]">
                      {cardB[cardIndex][1].subHeading}
                    </span>
                  )}
                </span>
              </p>
              <p className="text-black font-roboto text-[14px] md:text-[16px] font-light leading-[160%] tracking-[-0.32px]">
                {cardB[cardIndex][1].text}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UseCases;
